import React from "react";
import ReusableDataTable from "../../components/table/ReusableDataTable";

const data = [
  {
    name: "nguyen B",
    email: "nguyenvanb@gmail.com",
    phone: "123456789",
    department: "FPT Life",
    role: "OTA ROLE",
    address: "HCM",
  },
  {
    name: "nguyen van a",
    email: "nguyenvana@gmail.com",
    phone: "033789654",
    department: "FPT Life",
    role: "CMS ROLE",
    address: "HCM",
  },
  {
    name: "Supper Admin1",
    email: "supperadmin1@fpt.com.vn",
    phone: "",
    department: "admin",
    role: "SUPPER ADMIN",
    address: "N/A",
  },
  {
    name: "Supper Admin",
    email: "supperadmin@fpt.com.vn",
    phone: "0933393682",
    department: "admin",
    role: "SUPPER ADMIN",
    address: "No address",
  },
  {
    name: "Test User 6",
    email: "test6@example.com",
    phone: "1234567890",
    department: "Test Dept",
    role: "TEST ROLE",
    address: "Test Address",
  },
  {
    name: "Test User 7",
    email: "test7@example.com",
    phone: "0987654321",
    department: "Test Dept",
    role: "TEST ROLE",
    address: "Test Address",
  },
];

const columns = [
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "department", label: "Department" },
  { key: "role", label: "Role" },
  { key: "address", label: "Address" },
  { key: "actions", label: "Action" },
];

const UserTable = () => {
  return <ReusableDataTable columns={columns} data={data} maxHeight={300} />;
};

export default UserTable;
